import { render, staticRenderFns } from "./PrimaryContactInfo.vue?vue&type=template&id=00bb0b92"
import script from "./PrimaryContactInfo.vue?vue&type=script&lang=js"
export * from "./PrimaryContactInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports